var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRentersIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#ffffff",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#ffffff;stroke-miterlimit:10;stroke-width:1.91px;}")), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "12.96 22.5 1.5 22.5 1.5 5.32 7.23 1.5 12.96 5.32 12.96 22.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.27,8.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.09,8.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.27,12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.09,12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.27,15.82h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.09,15.82h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.27,
    y: 19.64,
    width: 1.91,
    height: 2.86
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "22.5 22.5 12.96 22.5 12.96 9.14 17.73 6.27 22.5 9.14 22.5 22.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.64,11.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.64,14.86h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.64,18.68h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRentersIcon);
export default __webpack_public_path__ + "static/media/renters-icon.570bbfc8f5ecf337a591bb08b9b3e7f1.svg";
export { ForwardRef as ReactComponent };